import React, { useState } from "react";
import {
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  Card,
  CardContent,
  InputAdornment,
  Button
} from "@mui/material";
import NavBar from "../../../components/NavBar";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  table: {
    minWidth: 650,
  },
  select: {
    width: "100%",
  },
  label: {
    fontWeight: "600",
    minWidth: 200,
    color: "rgb(0, 184, 230)",
  },
  selectContainer: {
    marginBottom: theme.spacing(1),
  },
}));

const initialData = [
  {
    personName: "Sudhir Patel",
    contactNumber: "7894561231",
    email: "sudhir@sample.co",
    relationWithCandidate: "Educational Connect",
    verificationDocuments: "upload",
  },
];

const labelValuePairs = [
  { label: "Degree", value: "M.B.A.", options: ["M.B.A.", "B.A.", "B.Sc."] },
  { label: "Specialization", value: "Marketing", options: ["Marketing", "Finance", "IT"] },
  { label: "Passing Year", value: "2018", options: ["2018", "2019", "2020"] },
  { label: "College", value: "L.J. Institute of Management and Studies", options: ["L.J. Institute of Management and Studies", "College 2", "College 3"] },
  { label: "Board", value: "G.T.U.", options: ["G.T.U.", "Board 2", "Board 3"] },
  { label: "Results", value: "9.1 out of 10 (CPI)", options: ["9.1 out of 10 (CPI)", "7.5", "6.5"] },
  { label: "Link of the Course", value: "Not Applicable", options: ["xyz.com", "zxc.com"] },
  { label: "Internship Company", value: "EStore Factory", options: ["EStore Factory", "XYZ"] },
  { label: "Internship Duration", value: "3 Months", options: ["3 Months", "5 Months"] },
  { label: "Document uploaded", value: "Degree_certi.pdf", options: ["Internship_certi.pdf", "training_deg.pdf"] },
];

const LabelField = ({ classes, label, value, options, onChange }) => {
  const isSocialMediaLink = label === "Link of the Course";
  const isDocumentUpload = label === "Document uploaded";
  const hasConfirmedLackData = options && options.length > 0;
  const [selectedValue, setSelectedValue] = useState(value);

  const handleLinkClick = () => {
    if (isSocialMediaLink) {
      window.open(value, "_blank");
    }
  };

  const handleDocumentClick = () => {
    if (isDocumentUpload) {
      window.open(value, "_blank", "fullscreen=yes");
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    onChange(label, newValue);
  };


  const handleConfirmedLackDataChange = (event) => {
    const isConfirmed = event.target.value === "Confirmed";
    const isLackOfData = event.target.value === "Lack of Data";
    let newValue = value;
    if (isConfirmed || isLackOfData) {
      const prefix = isConfirmed ? "(Confirmed)" : "(Lack of Data)";
      newValue = value.replace(/\(Confirmed\)|\(Lack of Data\)/, "").trim() + " " + prefix;
    }
    onChange(label, newValue);
  };

  return (
    <Card sx={{ boxShadow: 2, p: 2, marginBottom: "20px" }}>
      <CardContent>
      <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ fontSize: "20px" }}>
          {label + ":" + value}
        </Typography>
      </Grid>
      <Grid item xs={6}>
      <FormControl fullWidth>
                <InputLabel id="status">Status</InputLabel>
                <Select fullWidth label="Status" id="status">
                <MenuItem value="Confirmed">Confirmed</MenuItem>
                <MenuItem value="Not Confirmed">Not Confirmed</MenuItem>
                <MenuItem value="Lack of data / doc from Candidate">Lack of data / doc from Candidate</MenuItem>
                </Select>
            </FormControl>
      </Grid>
      <Grid item xs={6}>
      <FormControl fullWidth>
                <InputLabel id="source">Source of Verification</InputLabel>
                <Select fullWidth label="Source of Verification" id="source">
                <MenuItem value="Online">Online</MenuItem>
                <MenuItem value="Telephonic">Telephonic</MenuItem>
                <MenuItem value="Physical">Physical</MenuItem>
                <MenuItem value="iVeri link via mail">iVeri link via mail</MenuItem>
                </Select>
            </FormControl>
      </Grid>
      <Grid item xs={6}>
      <TextField  fullWidth variant="outlined" size="large" label="More Details"/>
      </Grid>
      <Grid item xs={6}>
      <Button
        variant="outlined"
        color="primary"
        component="label"
        htmlFor="upload-documents"
        style={{width:"157px",height:"55px"}}
      >
        Upload Docs
        <input type="file" id="upload-documents" style={{ display: "none" }} />
      </Button>
      </Grid>
      {/* <Grid item xs={6}>
        {isSocialMediaLink ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            <Typography onClick={handleLinkClick} style={{ cursor: "pointer" }}>
              {value}
            </Typography>
          </a>
        ) : isDocumentUpload ? (
          <Typography onClick={handleDocumentClick} style={{ cursor: "pointer" }}>
            {value}
          </Typography>
        ) : (
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <FormControl variant="standard" className={classes.select}>
            <Select
        labelId={`${label}-confirmed-lack-data-label`}
        id={`${label}-confirmed-lack-data-select`}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
            </FormControl>
            {hasConfirmedLackData && (
              <FormControl variant="standard" className={classes.select}>
                <Select
                  labelId={`${label}-confirmed-lack-data-label`}
                  id={`${label}-confirmed-lack-data-select`}
                  value={value.includes("Confirmed") ? "Confirmed" : value.includes("Lack of Data") ? "Lack of Data" : ""}
                  onChange={handleConfirmedLackDataChange}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="Confirmed">Confirmed</MenuItem>
                  <MenuItem value="Lack of Data">Lack of Data</MenuItem>
                </Select>
              </FormControl>
            )}
          </div>
        )}
      </Grid> */}
    </Grid>
      </CardContent>
    </Card>
  );
};

const EditEducational = () => {
  const classes = useStyles();
  const [data, setData] = useState(initialData);
  const [values, setValues] = useState({});

  const handleCellChange = (event, index, key) => {
    const updatedData = [...data];
    updatedData[index][key] = event.target.value;
    setData(updatedData);
  };

  const handleChange = (label, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [label]: value,
    }));
  };

  return (
    <>
      <NavBar />
      <Container maxWidth= "xs" style={{ marginTop: '80px' }}>
          {labelValuePairs.map(({ label, value, options }) => (
            <LabelField
              key={label}
              classes={classes} 
              label={label}
              value={values[label] || value}
              options={options}
              onChange={handleChange}
            />
          ))}
        
        
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Person Name</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Email ID</TableCell>
                <TableCell>Relation with Candidate</TableCell>
                <TableCell>Verification Documents</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell component="th" scope="row">
                    <TextField
                      value={row.personName}
                      onChange={(event) =>
                        handleCellChange(event, index, "personName")
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.contactNumber}
                      onChange={(event) =>
                        handleCellChange(event, index, "contactNumber")
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.email}
                      onChange={(event) =>
                        handleCellChange(event, index, "email")
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.relationWithCandidate}
                      onChange={(event) =>
                        handleCellChange(event, index, "relationWithCandidate")
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.verificationDocuments}
                      onChange={(event) =>
                        handleCellChange(event, index, "verificationDocuments")
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </Container>
    </>
  );
};

export default EditEducational;
